import NiceModal from "@ebay/nice-modal-react";
import PeopleDrawer from "models/people/PeopleDrawer";
import DealDrawer from "models/deals/DealDrawer";
import DealSharingLinksDrawer from "models/sharings/DealSharingLinksDrawer";
import SourcingDrawer from "models/sourcings/SourcingDrawer";
import ActionDrawer from "models/actions/ActionDrawer";
import CompanyDrawer from "models/companies/CompanyDrawer";
import NoteDrawer from "models/notes/NoteDrawer";
import SnapshotDrawer from "models/deals/SnapshotDrawer";
import DealSharingDrawer from "models/sharings/DealSharingDrawer";
import AsyncProcessesDrawer from "models/async_processes/AsyncProcessesDrawer";
import { SnackbarContext } from "components/context/SnackbarProvider";
import { useState, useContext, useCallback, useRef } from "react";
import { Drawer } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

NiceModal.register("PeopleDrawer", PeopleDrawer);
NiceModal.register("DealDrawer", DealDrawer);
NiceModal.register("SourcingDrawer", SourcingDrawer);
NiceModal.register("ActionDrawer", ActionDrawer);
NiceModal.register("CompanyDrawer", CompanyDrawer);
NiceModal.register("NoteDrawer", NoteDrawer);
NiceModal.register("SnapshotDrawer", SnapshotDrawer);
NiceModal.register("DealSharingDrawer", DealSharingDrawer);
NiceModal.register("AsyncProcessesDrawer", AsyncProcessesDrawer);
NiceModal.register("DealSharingLinksDrawer", DealSharingLinksDrawer);

export const useNiceModalLocker = (modal) => {
  const [locked, setLocked] = useState(false);
  const { displayMessage } = useContext(SnackbarContext);

  const closeFormIfNotLocked = useCallback(() => {
    if (!locked) modal.hide();
    else {
      displayMessage("Form is not saved !");
    }
  }, [locked, modal.id, displayMessage]);

  const forceClose = useCallback(() => {
    modal.hide();
    setLocked(false);
  }, [modal.id]);

  const setLockedClean = useCallback(
    (value) => {
      setLocked(true);
    },
    [displayMessage],
  );

  return {
    locked,
    setLocked: setLockedClean,
    closeFormIfNotLocked,
    forceClose,
  };
};

export const NiceModalComponent = ({ open, onClose, children }) => {
  return (
    <Drawer
      anchor="right"
      variant="temporary"
      PaperProps={{
        sx: { width: { sm: 600, xs: "100vw" }, flexShrink: { sm: 0 } },
      }}
      open={open}
      ModalProps={{ onClose }}
    >
      {children}
    </Drawer>
  );
};

export const CloseModalOnRouteChange = ({ children }) => {
  const location = useLocation();
  const niceModalContext = useContext(NiceModal.NiceModalContext);

  useEffect(() => {
    Object.keys(niceModalContext).forEach((key) => {
      NiceModal.hide(key);
    });
  }, [location.pathname]);

  return children;
};

export default function NiceModalProvider({ children }) {
  return (
    <NiceModal.Provider>
      <CloseModalOnRouteChange>{children}</CloseModalOnRouteChange>
    </NiceModal.Provider>
  );
}
